import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { trackEvent } from 'analytics/trackFunctions'

import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'

import ErrorIcon from 'assets/icons/ErrorIcon'
import { MeContext } from 'contexts/me'

const redirectWhatsApp = () => {
  window.open(
    `https://api.whatsapp.com/send?phone=5491152390637&text=`,
    '_blank'
  )
}

const OTPError = () => {
  const navigate = useNavigate()
  const { me } = useContext(MeContext)

  return (
    <PageWrapper noTabBar viewSelected='/home'>
      <section className='flex flex-col items-center sm:max-w-[22.5rem] mx-auto mt-24'>
        <ErrorIcon />
        <h1
          data-testid='firstErrMessage'
          className='font-bold text-black text-xl text-center leading-5 mt-8'
        >
          No pudimos enviar el mensaje de texto al ******{' '}
          {me?.profile.phone.slice(-3)}.
        </h1>
        <p
          data-testid='secondErrMessage'
          className='font-medium text-gray-900 text-base mt-2 mb-20 text-center'
        >
          Comunicate con atención al cliente para modificarlo o solucionar el
          error.
        </p>
        <PrimaryButton
          buttonText='Necesito ayuda'
          className='mb-4'
          primaryButtonFunction={() => {
            redirectWhatsApp()
          }}
          outlined
        />
        <PrimaryButton
          buttonText='Volver atrás'
          primaryButtonFunction={() => {
            trackEvent({
              eventName: 'bille_adelantos_boton_error_oferta_reintentar'
            })
            navigate(-1)
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default OTPError
